/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-unneeded-ternary */
import { createEvent, createStore } from 'effector';
export const setShowSkin = createEvent();
export const handleSkin = createEvent();
export const skinDetails = createStore(null).on(handleSkin, (_, payload) => payload);
export const showSkin = createStore(false).on(setShowSkin, (_, payload) => payload);
